export default (props, vars) => () =>
  window
    .open(vars?.['applicationcard2']?.['item'].current_step.action, '_blank')
    .focus();
